import { Outlet, useLocation } from 'react-router-dom';
import AnnouncementBar from '../AnnouncementBar/AnnouncementBar';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import RouteMetadata from '../RouteMetadata';
import WhatsAppButton from '../../common/WhatsAppButton/WhatsAppButton';
function PublicLayout() {
  const { pathname } = useLocation();
  const focused = /^\/(login|register|forgot-password|verification-pending|checkout|order-confirmation|account|orders|admin)(\/|$)/.test(pathname);
  return <div className={focused ? 'app-shell app-shell--focused' : 'app-shell'}><RouteMetadata /><a className="skip-link" href="#main-content">Skip to main content</a><div className={focused ? 'site-chrome site-chrome--compact' : 'site-chrome'}>{!focused && <AnnouncementBar />}<Header compact={focused} /></div><div id="main-content" tabIndex="-1"><Outlet /></div>{!focused && <Footer />}{!focused && <WhatsAppButton />}</div>;
}
export default PublicLayout;
